import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHealth = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2894_18187)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M24 18.6666L30.6667 17.3333L24 26.6666L16 29.3333L7.99999 26.6666L1.33332 17.3333L7.99999 18.6666M16 29.3333L13.3333 16M16 29.3333L18.6667 16M16 29.3333L7.99999 18.6666M16 29.3333L24 18.6666M7.99999 18.6666L6.66665 10.6666L13.3333 16M13.3333 16L16 2.66663L18.6667 16M18.6667 16L25.3333 10.6666L24 18.6666M1.00012 11H1.05012M31.0001 11H31.0501",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2894_18187",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgHealth;
